import React, { useState } from 'react';
import { ImageOff, ZoomIn } from 'lucide-react';

// Keyed by URL by the caller: a freshly synced URL gets a fresh image-error state.
export default function HongguoRankingCover({ url, title, onPreview, preview = false }) {
  const [failed, setFailed] = useState(false);
  if (!url || failed) {
    return <span className={`hongguo-rankings-cover-fallback${preview ? ' is-preview' : ''}`} role="img" aria-label={`${title}：${failed ? '封面加载失败' : '暂无封面'}`}>
      <ImageOff size={preview ? 30 : 18} aria-hidden="true" />
      <span>{failed ? '封面暂不可用' : '暂无封面'}</span>
    </span>;
  }
  const image = <img src={url} alt={`${title}封面`} loading={preview ? 'eager' : 'lazy'} decoding="async" referrerPolicy="no-referrer" width={160} height={224} onError={() => setFailed(true)} />;
  return preview ? <div className="hongguo-rankings-cover-large">{image}</div> : <button type="button" className="hongguo-rankings-cover" onClick={onPreview} aria-label={`放大封面：${title}`} title="点击放大封面">
    {image}<span className="hongguo-rankings-cover-zoom" aria-hidden="true"><ZoomIn size={13} /></span>
  </button>;
}
